<template>
  <div id="layout" class="layout">
    <div class="header-info">
      <div class="top-left">{{ headerTitle }}</div>
      <div class="top-right">
        <div class="bg-user">
          <span class="user-name">欢迎您，{{ userName }}</span>
          <span class="button_img" style="margin-left: 4px;overflow: hidden;">
            <img
              class="img-name"
              src="@/assets/images/icon_shang.png"
              style="transition: all 0.3s;"
              :style="{transform: `rotate(${isUser ? '0' : '-180deg'})`}"
            />
          </span>
          <div v-show="isUser">
            <div class="bar-console">
              <span @click="changePassword">修改密码</span>
            </div>
          </div>
        </div>
        <div class="bg-white" @click="closeLogin">
          <img src="@/assets/images/icon_kg.png" alt />
        </div>
      </div>
    </div>
    <el-container style="height: calc(100vh - 50px)">
      <Aside />

      <el-container>
        <el-header>
          <!--页面标签栏-->
          <Breadcrumb />
        </el-header>

        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="570px"
      @closed="handleDialogClosed"
    >
      <el-form ref="userform" :rules="userformRule" :model="userform" label-width="80px">
        <el-form-item label="登录账号">
          <el-input disabled v-model="userform.userAcc"  size="medium" placeholder="输入登录账号（6-16位字母数字）"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="userPwdOne">
          <el-input v-model.trim="userform.userPwdOne" type="password" maxlength="16" clearable size="medium" placeholder="支持6-16位字母、数字或组合" @input="limitInput('userPwdOne')"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="userPwdTwo">
          <el-input v-model.trim="userform.userPwdTwo" type="password" maxlength="16" clearable size="medium" placeholder="支持6-16位字母、数字或组合"  @input="limitInput('userPwdTwo')"></el-input>
        </el-form-item>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="handleSuccess">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { Aside, Breadcrumb } from "./components";
import axios from "axios";
export default {
  name: "Layout",
  components: { Aside, Breadcrumb },
  data() {
    return {
      userImg: "",
      isUser: false,
      headerTitle: "繁星合作渠道-管理后台",
      user: {},
      userName: "",
      dialogVisible: false,
      userform: {
        userAcc:'',
        userPwdOne: '',
        userPwdTwo: '',
      },
      userformRule: {
        userPwdOne: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在6到16个字符', trigger: 'blur' }
        ],
        userPwdTwo: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在6到16个字符', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              if (value !== this.userform.userPwdOne) {
                callback(new Error('确认密码与新密码不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur' }
        ],
      },
      butLoading: false,
    };
  },
  created() {

    this.userImg = localStorage.getItem("userImg");
    this.userName = localStorage.getItem("userName");
    this.user=JSON.parse(localStorage.getItem('user'))
    document.body.addEventListener('click',(e)=>{
      if(e.target.className == 'bg-user'||e.target.className == 'user-name' ||e.target.className == 'button_img'||e.target.className =='img-name'){
        this.isUser = !this.isUser
      }else{
        this.isUser = false
      }
    })
  },
  methods: {
    closeLogin() {
      this.$confirm("你是否要退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出登录成功!",
          });
          _api.logout({ token: localStorage.getItem("token") }).then((res) => {
            if (res.code === 1) {
              // localStorage.clear();
              localStorage.removeItem('token')
              localStorage.removeItem('userImg')
              localStorage.removeItem('userName')
              localStorage.removeItem('roleId')
              this.$router.push("/login");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 打开修改密码弹框
    changePassword() {
      this.userform.userAcc = this.userName
      this.dialogVisible = true
      this.isUser = false
    },
    handleDialogClosed(){
      this.$refs['userform'].resetFields();
    },
    handleSuccess(){
      console.log(this.userform);
      this.$refs['userform'].validate((valid) => {
        if (valid) {
          this.butLoading = true;
          _api.assignStaffPwd(this.userform).then(res => {
            if(res.code==1){
              this.$message.success('操作成功')
              this.dialogVisible = false
              this.$router.push("/login")
            }
          }).finally(() => {
            this.butLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.layout {
  aside,
  main {
    /*滚动条样式设置*/
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.4em;
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 0.5em;
      -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
    }
    /*滑块*/
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 0.5em;
      -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
    }
    /*滑块轨道*/
    &::-webkit-scrollbar-track {
      border-radius: 0.5em;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    }
  }
  .el-header {
    width: 100%;
    font-size: 12px;
    background-color: #f5f6fa;
    color: #333;
    //line-height: 60px;
    height: auto !important;
    box-shadow: 0px 1px 3px 0px rgba(208, 208, 208, 0.8);
  }

  .el-aside {
    color: #333;
  }

  .header-info {
    height: 50px;
    background: #0981ff;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top-left {
      width: 250px;
      height: 50px;
      line-height: 50px;
      font-size: 20px;
      font-family: MF LangQian (Noncommercial);
      font-weight: 400;
      color: #ffffff;
      margin-left: 20px;
    }
    .top-right {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      margin-right: 20px;
      .bg-white {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          border-radius: 50%;
        }
      }
      .bg-user {
        display: flex;
        height: 20px;
        font-size: 14px;
        font-family: FZLanTingHei-M-GBK;
        font-weight: 400;
        color: #ffffff;
        margin: 0 20px 0 10px;
        cursor: pointer;
        .bar-console {
          z-index: 9999;
          position: absolute;
          right: 60px;
          top: 50px;
          width: 100px;
          height: 60px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 4px 10px 0px rgba(92, 92, 92, 0.15);
          opacity: 0.9;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          span {
            cursor: pointer;
            width: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            &:hover {
              background-color: rgba(#d4d9f8, 0.5);
            }
          }
        }
        .button {
          width: 12px;
          height: 15px;
          border-radius: 3px;
          cursor: pointer;
          > img {
            vertical-align: middle;
          }
        }
        .button_img {
          display: flex;
          align-items: center;
          width: 12px;
          height: 15px;
          border-radius: 3px;
          cursor: pointer;
          > img {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
.bance3203 {
  background-color: #fff;
  border-radius: 8px;
  padding: 5px 10px;
  color: red;
  font-weight: 700;
  margin-right: 100px;
}
</style>
